import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand315: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExpand315"><Path fillRule="evenodd" clipRule="evenodd" d="M11 3H3V11H5V6.41421L10 11.4142L11.4142 10L6.41421 5H11V3ZM12.5858 14L17.5858 19H13V21H21V13H19V17.5858L14 12.5858L12.5858 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand315;
